import { Toaster } from "react-hot-toast";

const ToasterComponents = () => {
  return (
    <Toaster
      toastOptions={{
        duration: 4000,
        style: {
          background: "#363636",
          color: "#fff",
          fontSize: 14,
        },
      }}
    />
  );
};

export default ToasterComponents;
